function setCookie(name: string, value: string, path = "/", days?: number) {
  let expires = "";
  const pathPart = path ? `; path=${path}` : ""
  if (days) {
      const date = new Date();
      date.setTime(date.getTime() + (days*24*60*60*1000));
      expires = `; expires=${date.toUTCString()}`;

  }
  document.cookie = `${name}=${(value || "")}${expires}${pathPart}`;
}

export default setCookie